import { render, staticRenderFns } from "./Overrides.vue?vue&type=template&id=31c9f194&scoped=true"
import script from "./Overrides.vue?vue&type=script&lang=js"
export * from "./Overrides.vue?vue&type=script&lang=js"
import style0 from "./Overrides.vue?vue&type=style&index=0&id=31c9f194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c9f194",
  null
  
)

export default component.exports